<template>

    <v-action :name="name">
        <v-input
            size="sm"
            :placeholder="placeholder"
            :model="block[key]"
            @input="onInput" />
    </v-action>

</template>

<script>

import Action from './Action';

export default {

    components: {
        'v-action': Action,
    },

    props: {
        type: {
            type: String,
            required: true,
        },
    },

    computed: {

        block() {
            return this.$store.getters['builder/selectedBlock'];
        },

        name() {
            if (this.type === 'link') {
                return 'Link';
            }
            return 'Text';
        },

        key() {
            if (this.type === 'link') {
                return 'link';
            }
            return 'text';
        },

        placeholder() {
            if (this.type === 'link') {
                return 'https://';
            }
            return '';
        },

    },

    methods: {

        onInput(val) {
            let block = this.block;
            block[this.key] = val;
            this.$store.commit('builder/setSelectedBlock', block);
        },

    },

}

</script>